import { Link } from 'react-router-dom';
import { FiActivity, FiBookOpen, FiLayers, FiRefreshCcw } from 'react-icons/fi';
import SEO from '../components/SEO';
import { ROUTE_META } from '../data/routeMeta';

const features = [
  { icon: FiBookOpen, title: 'VIT Grade Mapping', detail: 'S to F rules baked in' },
  { icon: FiLayers, title: 'Weighted CGPA', detail: 'Credit-based cumulative tracking' },
  { icon: FiRefreshCcw, title: 'Real-time Updates', detail: 'No calculate button required' },
  { icon: FiActivity, title: 'Quick Conversion', detail: '10/5/4/100 scale support' }
];

export default function HomePage() {
  const meta = ROUTE_META['/'];

  return (
    <>
      <SEO title={meta.title} description={meta.description} keywords={meta.keywords} canonicalPath="/" />

      <section className="mx-auto max-w-4xl space-y-6 text-center">
        <p className="inline-flex rounded-xl border border-brand-border bg-brand-accentSoft px-3 py-1 text-xs font-semibold text-brand-accent">
          Built for VIT, Vellore
        </p>
        <h1 className="text-4xl font-bold tracking-tight md:text-5xl">
          Fast{' '}
          <span className="bg-gradient-to-r from-brand-accent to-brand-text bg-clip-text text-transparent">
            GPA, CGPA & Grade Conversion
          </span>{' '}
          with zero clutter.
        </h1>
        <p className="mx-auto max-w-2xl text-base text-brand-muted">
          Minimalist academic tools with accurate formulas, responsive layouts, and instant results.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/gpa-calculator" className="rounded-xl bg-brand-accent px-5 py-3 text-sm font-semibold text-white">
            Open GPA Calculator
          </Link>
          <Link to="/cgpa-calculator" className="elevated rounded-xl border border-brand-border bg-brand-surface px-5 py-3 text-sm font-semibold text-brand-text">
            Open CGPA Calculator
          </Link>
        </div>
      </section>

      <section className="mt-10 grid gap-3 md:grid-cols-4">
        {features.map((feature) => {
          const Icon = feature.icon;
          return (
            <article key={feature.title} className="elevated rounded-2xl border border-brand-border bg-brand-surface p-4 text-center">
              <Icon className="mx-auto text-brand-accent" size={18} />
              <h3 className="mt-2 text-sm font-semibold">{feature.title}</h3>
              <p className="mt-1 text-xs text-brand-muted">{feature.detail}</p>
            </article>
          );
        })}
      </section>
    </>
  );
}
